import fasIzzi1 from "./fas-izzi (1).png";
import fasIzzi2 from "./fas-izzi (2).png";
import fasIzzi3 from "./fas-izzi (3).png";
import fasIzzi4 from "./fas-izzi (4).png";
import fasIzzi5 from "./fas-izzi (5).png";

const fasizzi = [fasIzzi1, fasIzzi2, fasIzzi3, fasIzzi4, fasIzzi5];

export default fasizzi;
